export enum AuthActionType {
  LOG_IN = 'LOG_IN',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
  FULL_LOADING = 'FULL_LOADING',
  LOG_OUT = 'LOG_OUT',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  GET_USER_INFO = 'GET_USER_INFO',
  SET_NOTIFICATION = 'SET_NOTIFICATION',
  SET_RECOVERY_TOKEN = 'SET_RECOVERY_TOKEN',
  SET_TENANT = 'SET_TENANT',
}
